import React from "react";
import { IListingDocument } from "../../lib";

export enum EListingDocumentsLayout {
    oneColumn = "oneColumn",
    threeColumns = "threeColumns",
}

export interface IListingDocumentsProps {
    title?: string;
    className?: string;
    documents: IListingDocument[];
    layout?: EListingDocumentsLayout;
}

export const ListingDocuments: React.FC<IListingDocumentsProps> = ({
    title,
    className,
    documents,
    layout = EListingDocumentsLayout.threeColumns,
}) => {

    let layoutSpecs = {
        list: "",
        listItem: "",
    };

    switch (layout) {
        case EListingDocumentsLayout.threeColumns:
            layoutSpecs = {
                ...layoutSpecs,
                list: "mt-4 grid gap-4 grid-cols-1 md:grid-cols-2 lg:grid-cols-3",
            };
            break;
        case EListingDocumentsLayout.oneColumn:
            layoutSpecs = {
                ...layoutSpecs,
                list: "mt-4 grid gap-4 grid-cols-1",
            };
            break;
    }

    return (
        <div className={`listing-documents ${className}`}>
            {title && <h2 className="text-h2-text">{title}</h2>}
            <ul className={`list-none max-w-screen-xl ${layoutSpecs.list}`}>
                {documents.map((document, index) => {
                    return (
                        <li className={layoutSpecs.listItem} key={index}>
                            <a target={"_blank"} href={document.file.url}>{document.title}</a>
                        </li>
                    )
                })}
            </ul>
        </div>
    );
};

export default ListingDocuments;
